import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=6990336b&scoped=true&"
import script from "./CompanyProfile.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990336b",
  null
  
)

export default component.exports